//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetNext",{R_:{nextEvent:"CAM.PathEvent"}},0,0],[[],"GetPrevious",{R_:{previousEvent:"CAM.PathEvent"}},0,0],[[],"GetRegionMesh",{R_:{regionMesh:"Facet.FacetedBody"}},0,0],[["cornerMarkerData"],"GetCornerMarkerData",{R_:{result:''}},0,0],[["sixthAxisData"],"GetSixthAxis",{R_:{result:''}},0,0]],[]];
SPLM.CAM.PathEvent = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PathEvent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;